module.exports = __webpack_public_path__ + "static/img/M_MINI_BAGS.24aeefa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M_MINI_BAGS.jpg
// module id = LPza
// module chunks = 1